<h1 mat-dialog-title>{{'warningDeconnection' | translation}}</h1>
<div mat-dialog-content>
  <!-- <p>What's your favorite animal?</p>
  <mat-form-field>
    <input matInput [(ngModel)]="data.animal">
  </mat-form-field> -->
</div>
<div mat-dialog-actions>

  <button mat-button color="warn" (click)="onDelete()">{{'deco' | translation}}</button>
  <button mat-button (click)="onEdit()" cdkFocusInitial>{{'cancel' |translation}}</button>
  <!-- <button mat-button [mat-dialog-close]="data.buttonValue" cdkFocusInitial>Supprimer</button> -->
</div>

<!-- <h1 mat-dialog-title>Hi {{data.name}}</h1>
<div mat-dialog-content>
  <p>What's your favorite animal?</p>
  <mat-form-field>
    <input matInput [(ngModel)]="data.animal">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No Thanks</button>
  <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button>
</div> -->
